export default __webpack_public_path__ + "media/Cybersecurity.a16ad9a6.svg";